export enum ImportProductsErrorCode {
  MISSING_PRODUCT_ID = 'MISSING_PRODUCT_ID',
  MISSING_PRODUCT_NAME = 'MISSING_PRODUCT_NAME',
  MISSING_REGION = 'MISSING_REGION',
  WRITE_YES_NO_FOR_SUSTAINABLE_ALTERNATIVE_AVAILABLE = 'WRITE_"YES"_OR_"NO"_FOR_SUSTAINABLE_ALTERNATIVE_AVAILABLE',
  MISSING_SUSTAINABLE_ALTERNATIVE_AVAILABLE = 'MISSING_SUSTAINABLE_ALTERNATIVE_AVAILABLE',
  INVALID_TAGS = 'INVALID_TAGS',
  MAXIMUM_TAGS_LIMIT_EXCEEDED = 'MAXIMUM_TAGS_LIMIT_EXCEEDED',
  MAXIMUM_LENGTH_PER_TAG_EXCEEDED = 'MAXIMUM_LENGTH_PER_TAG_EXCEEDED',
  DUPLICATE_TAGS_ARE_NOT_ALLOWED = 'DUPLICATE_TAGS_ARE_NOT_ALLOWED',
  PCF_VALUE_NOT_FOUND = 'PCF_VALUE_NOT_FOUND',
  UNSUPPORTED_REGION_NAME = 'UNSUPPORTED_REGION_NAME',
  IMPORT_PRODUCT_FAILED_TO_CREATE_DIGITAL_TWIN = 'IMPORT_PRODUCT_FAILED_TO_CREATE_DIGITAL_TWIN',
}

export const ImportProductsErrorCodeTranslationKeyMap = {
  [ImportProductsErrorCode.MISSING_PRODUCT_ID]: 'missingProductId',
  [ImportProductsErrorCode.MISSING_PRODUCT_NAME]: 'missingProductName',
  [ImportProductsErrorCode.MISSING_REGION]: 'missingRegion',
  [ImportProductsErrorCode.WRITE_YES_NO_FOR_SUSTAINABLE_ALTERNATIVE_AVAILABLE]:
    'writeYesNoForSustainableAlternativeAvailable',
  [ImportProductsErrorCode.MISSING_SUSTAINABLE_ALTERNATIVE_AVAILABLE]:
    'writeYesNoForSustainableAlternativeAvailable',
  [ImportProductsErrorCode.INVALID_TAGS]: 'invalidTags',
  [ImportProductsErrorCode.MAXIMUM_TAGS_LIMIT_EXCEEDED]: 'maximumTagsLimitExceeded',
  [ImportProductsErrorCode.MAXIMUM_LENGTH_PER_TAG_EXCEEDED]: 'maximumLengthPerTagExceeded',
  [ImportProductsErrorCode.DUPLICATE_TAGS_ARE_NOT_ALLOWED]: 'duplicateTagsAreNotAllowed',
  [ImportProductsErrorCode.PCF_VALUE_NOT_FOUND]: 'pcfValueNotFound',
  [ImportProductsErrorCode.UNSUPPORTED_REGION_NAME]: 'unsupportedRegionName',
  [ImportProductsErrorCode.IMPORT_PRODUCT_FAILED_TO_CREATE_DIGITAL_TWIN]:
    'failedToCreateDigitalTwin',
};

export enum ImportProductAssignmentsErrorCode {
  MISSING_PRODUCT_ID = 'MISSING_PRODUCT_ID',
  MISSING_COMPANY_ID = 'MISSING_COMPANY_ID',
  MISSING_REGION = 'MISSING_REGION',
  UNSUPPORTED_REGION_NAME = 'UNSUPPORTED_REGION_NAME',
  UNKNOWN_COMPANY = 'UNKNOWN_COMPANY',
  PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND',
}

export const ImportProductAssignmentsErrorCodeTranslationKeyMap = {
  [ImportProductAssignmentsErrorCode.MISSING_PRODUCT_ID]: 'missingProductId',
  [ImportProductAssignmentsErrorCode.MISSING_COMPANY_ID]: 'missingCompanyId',
  [ImportProductAssignmentsErrorCode.MISSING_REGION]: 'missingRegion',
  [ImportProductAssignmentsErrorCode.UNSUPPORTED_REGION_NAME]: 'unsupportedRegionName',
  [ImportProductAssignmentsErrorCode.UNKNOWN_COMPANY]: 'unknownCompany',
  [ImportProductAssignmentsErrorCode.PRODUCT_NOT_FOUND]: 'productNotFound',
};
